import { useQuery } from "@tanstack/react-query";
import { ActivityKeys } from "web_myplann/Api/Activities/ActivityKeys";
import { getActivityIdParticipantsV2 } from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const useActivityParticipantsQuery = (id: number) => {
	return useQuery({
		queryKey: ActivityKeys.detailParticipants(id),
		queryFn: processResponse(() => getActivityIdParticipantsV2(id)),
		enabled: id !== 0,
	});
};
